import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { FaBars } from 'react-icons/fa';

const TopNav = ({ toggleSidebar }) => {
  const { instance, accounts } = useMsal();
  const account = accounts[0];
  const isAuthenticated = !!account;

  const [photoUrl, setPhotoUrl] = useState(null);

  const handleLogin = () => {
        instance.loginRedirect({
            redirectStartPage: '/overview'
        });
    };
  const handleLogout = () => instance.logoutRedirect();

  useEffect(() => {
    const fetchProfilePhoto = async () => {
      try {
        const response = await instance.acquireTokenSilent({
          scopes: ['User.Read'],
          account,
        });

        const photoResponse = await fetch('https://graph.microsoft.com/v1.0/me/photo/$value', {
          headers: {
            Authorization: `Bearer ${response.accessToken}`,
          },
        });

        if (photoResponse.ok) {
          const blob = await photoResponse.blob();
          setPhotoUrl(URL.createObjectURL(blob));
        }
      } catch (err) {
        console.warn('Could not fetch profile photo:', err.message);
      }
    };

    if (isAuthenticated) {
      fetchProfilePhoto();
    }
  }, [account, instance, isAuthenticated]);

  const getInitials = (name) => name?.split(' ').map(n => n[0]).join('').toUpperCase();

  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 1001, backgroundColor: '#fff', borderBottom: '1px solid #ddd', padding: '1rem 2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '64px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <img src="/logo/rimo3-logo-black.svg" alt="Logo" style={{ height: '32px' }} />
        <span style={{ fontSize: '1.1rem', fontWeight: '600', color: '#333' }}>
          Strategic Content Accelerator
        </span>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        {isAuthenticated && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            {photoUrl ? (
              <img src={photoUrl} alt="Profile" style={{ borderRadius: '50%', width: '36px', height: '36px' }} />
            ) : (
              <div style={{ backgroundColor: '#EA7400', color: '#fff', fontWeight: 'bold', borderRadius: '50%', width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '0.9rem' }}>
                {getInitials(account?.name || account?.username)}
              </div>
            )}
            <span style={{ fontSize: '0.9rem', color: '#333' }}>{account.name}</span>
          </div>
        )}

        <button onClick={isAuthenticated ? handleLogout : handleLogin} className="desktop-logout" style={{ padding: '0.5rem 1rem', backgroundColor: '#EA7400', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.9rem', display: 'none' }}>
          {isAuthenticated ? 'Logout' : 'Login'}
        </button>

        <FaBars onClick={toggleSidebar} className="mobile-menu-toggle" style={{ fontSize: '1.25rem', cursor: 'pointer', display: 'none' }} />
      </div>
    </div>
  );
};

export default TopNav;